var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"datePickerComp"},[_c('date-picker',{attrs:{"range":true,"type":'date',"confirm":true,"width":'100%',"clearable":true,"shortcuts":_vm.shortcuts,"lang":_vm.lang},on:{"clear":function($event){_vm.time = ''}},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }